<template>
	<div>
		<div id="wrap">
			<div>
				<el-button type="primary" @click="handleAdd">添加</el-button>
				<el-button type="primary" @click="upload.open = true"
					>批量导入</el-button
				>
			</div>

			<el-form :inline="true" class="from" ref="formQuery" :model="queryParams">
				<el-form-item label="时间：">
					<el-date-picker
						v-model="queryParams.time"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="timeChange"
					>
					</el-date-picker>
				</el-form-item>
				<el-input
					placeholder="请输入材料名称"
					style="width:200px;margin-left:20px;"
					v-model="queryParams.name"
				></el-input>
				<el-form-item class="item_btn">
					<el-button type="primary" @click="handleQuery">查询</el-button>
					<el-button type="primary" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
			<div class="flex flex-end"></div>

			<!-- 导入 -->
			<el-dialog
				title="批量导入"
				:visible.sync="upload.open"
				center
				width="44%"
			>
				<div class="dialog_content">
					<div class="download" style="margin-top: 20px;line-height: 25px">
						<div>填写需要导入的数据</div>
						<div style="color: #a3adb9">
							请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
						</div>
						<div>
							<el-link type="primary" :underline="false" @click="importTemplate"
								>下载模板</el-link
							>
						</div>
					</div>
					<div class="upload" style="margin-top: 20px;line-height: 25px">
						<div>上传填好的表格</div>
						<div style="color: #a3adb9">
							文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
						</div>
						<el-upload
							class="upload-demo"
							ref="upload"
							:limit="1"
							accept=".xlsx, .xls"
							:action="upload.url"
							:disabled="upload.isUploading"
							:auto-upload="false"
							:data="{ projectId: projectId }"
							:on-progress="handleFileProgress"
							:on-success="handleFileSuccess"
							:on-exceed="handleFileExceed"
						>
							<el-link type="primary" :underline="false">上传文件</el-link>
						</el-upload>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="upload.open = false">取 消</el-button>
					<el-button type="primary" @click="submitFileForm">保存</el-button>
				</div>
			</el-dialog>

			<el-dialog
				title="材料管理"
				:visible.sync="centerDialogVisible"
				width="30%"
				center
			>
				<div>
					<el-form
						label-width="120px"
						:model="formData"
						:rules="rules"
						ref="formData"
					>
						<el-form-item v-if="!type" prop="projectId" label="选择项目：">
							<el-select v-model="formData.projectId" placeholder="设备类型">
								<el-option
									v-for="dict in projectList"
									:key="dict.id"
									:label="dict.projectName"
									:value="dict.id"
									placeholder="请选择"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="getTime" label="领取时间">
							<el-date-picker
								:editable="false"
								value-format="yyyy-MM-dd"
								:picker-options="pickerOptions"
								v-model="formData.getTime"
								placeholder="请选择"
							></el-date-picker>
						</el-form-item>
						<el-form-item prop="receiptNumber" label="单据编号">
							<el-input v-model="formData.receiptNumber" disabled></el-input>
						</el-form-item>
						<el-form-item prop="materialName" label="材料名称">
							<el-input v-model="formData.materialName"></el-input>
						</el-form-item>
						<el-form-item prop="specification" label="型号规格">
							<el-input v-model="formData.specification"></el-input>
						</el-form-item>
						<el-form-item prop="unit" label="单位">
							<!-- <el-input v-model="formData.unit"></el-input> -->
							<el-select v-model="formData.unit" placeholder="请选择">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="consumeCount" label="消耗数量">
							<el-input-number
								:min="1"
								:controls="false"
								v-model="formData.consumeCount"
							></el-input-number>
						</el-form-item>
						<el-form-item prop="price" label="单价">
							<el-input-number
								:min="1"
								:controls="false"
								@blur="amountBlur"
								v-model="formData.price"
							>
								<!-- <template slot="append">元</template> -->
							</el-input-number>
						</el-form-item>
						<el-form-item prop="amount" label="金额">
							<el-input-number
								:controls="false"
								disabled
								v-model="formData.amount"
							></el-input-number>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">返回</el-button>
					<el-button type="primary" @click="classSubmitForm">保存</el-button>
				</span>
			</el-dialog>

			<el-table
				class="table"
				:data="datas"
				:header-cell-style="{ background: '#F5F7FA' }"
				v-loading="loading"
				:row-class-name="tableRowClassName"
			>
				<el-table-column
					label="所属项目"
					prop="projectName"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					prop="getTime"
					label="领料时间"
					width="120"
					show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
					prop="receiptNumber"
					label="单据编号"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					label="材料名称"
					prop="materialName"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					label="型号规格"
					prop="specification"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					label="单位"
					prop="unit"
					show-overflow-tooltip
				></el-table-column>

				<el-table-column
					label="消耗数量"
					prop="consumeCount"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					label="更新时间"
					prop="updateTime"
					show-overflow-tooltip
				></el-table-column>

				<el-table-column label="操作" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							class="green"
							@click="handleUpdate(scope.row.id)"
							>编辑</el-button
						>
						<el-button
							type="text"
							size="small"
							class="red"
							@click="handleDelete(scope.row.id)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<div class="flex flex-end">
				<el-pagination
					class="pagination"
					background
					v-show="total > 0"
					:total="total"
					:current-page.sync="queryParams.pageNum"
					:page-size.sync="queryParams.pageSize"
					@current-change="getList"
				>
				</el-pagination>
			</div>
		</div>
		<import-tips
			:show="importOpen"
			:data="importData"
			:succeedNumber="importSucceedNumber"
			:errorNumber="importErrorNumber"
			@importOpnes="importOpnes"
		/>
	</div>
</template>

<script>
import importTips from "./importTips.vue";
import {
	importDateDownloadTemplate,
	projectManagementGet,
	materialManagementQueryAll,
	materialManagementQuery,
	materialManagementSave,
	materialManagementDelete
} from "../fixedAssets";

export default {
	components: {
		importTips
	},
	props: {
		projectId: {
			type: String,
			default: ""
		},
		type: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			upload: {
				// 是否显示弹出层
				open: false,
				// 是否禁用上传
				isUploading: false,
				// 上传的地址
				url:
						this.mainBaseURL +
					"/materialManagement/importMaterialManagements"
			},
			importOpen: false,
			importData: [],
			importSucceedNumber: 0,
			importErrorNumber: 0,
			centerDialogVisible: false,
			dialogFormVisible_daoru: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10
			},
			options: [
				{
					value: "斤",
					label: "斤"
				},
				{
					value: "个",
					label: "个"
				},
				{
					value: "公斤",
					label: "公斤"
				},
				{
					value: "吨",
					label: "吨"
				},
				{
					value: "克",
					label: "克"
				},
				{
					value: "升",
					label: "升"
				}
			],
			datas: [],
			total: 1,
			formData: {},
			rules: {
				getTime: [
					{ required: true, message: "请选择领取时间", trigger: "change" }
				],
				// receiptNumber: [ {required: true, message: "请输入单据编号", trigger: "blur"} ],
				materialName: [
					{ required: true, message: "请输入材料名称", trigger: "blur" }
				],
				specification: [
					{ required: true, message: "请输入型号规格", trigger: "blur" }
				],
				unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
				consumeCount: [
					{ required: true, message: "请输入消耗数量", trigger: "blur" }
				],
				price: [{ required: true, message: "请输入单价", trigger: "blur" }],
				amount: [{ required: true, message: "请输入金额", trigger: "blur" }]
			},
			amortizationTotal: "",
			projectList: [],
			// 遮罩层
			loading: true,
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			}
		};
	},
	created() {
		this.resetQuery();
	},
	methods: {
		amountBlur() {
			this.formData.amount = this.formData.consumeCount * this.formData.price;
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 列表 */
		getList() {
			this.loading = true;
			materialManagementQueryAll(this.queryParams).then(res => {
				if (res.code == "00000") {
					this.datas = res.data.records;
					this.total = res.data.total;
				}
				this.loading = false;
			});
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 重置按钮操作 */
		resetQuery() {
			this.resetForm("formQuery");
			this.queryParams = {};
			if (this.type) {
				this.queryParams.projectId = this.projectId;
			}
			this.queryParams.startTime = "";
			this.queryParams.endTime = "";
			this.handleQuery();
		},
		// 表单重置
		reseForm() {
			this.formData = {};
			if (!this.type) {
				projectManagementGet().then(res => {
					this.projectList = res.data;
				});
			} else {
				this.formData.projectId = this.projectId;
			}
			this.resetForm("formData");
		},
		// 新增
		handleAdd() {
			this.reseForm();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.reseForm();
			materialManagementQuery(id).then(res => {
				this.formData = res.data;
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.$refs["formData"].validate(valid => {
				if (valid) {
					materialManagementSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.handleQuery();
							this.centerDialogVisible = false;
							this.msgSuccess(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			this.$confirm("是否确认删除材料?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return materialManagementDelete({ ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		},
		// 日期选择
		timeChange(val) {
			if (val != null) {
				this.queryParams.startTime = val[0] + " 00:00:00";
				this.queryParams.endTime = val[1] + " 23:59:59";
			} else {
				this.queryParams.startTime = "";
				this.queryParams.endTime = "";
			}
		},
		importTemplate() {
			importDateDownloadTemplate(4).then(res => {
				if (res.code == "00000") {
					window.open(res.data, "_blank");
				}
			});
		},
		handleFileProgress(event, file, fileList) {
			this.upload.isUploading = true;
		},
		handleFileSuccess(response, file, fileList) {
			if (response.code == "00000") {
				this.upload.open = false;
				this.upload.isUploading = false;
				this.$refs.upload.clearFiles();
				this.importOpen = true;
				this.importData = response.data.errorList;
				this.importSucceedNumber = response.data.succeedNumber;
				this.importErrorNumber = response.data.errorNumber;
				this.getList();
			} else {
				this.upload.isUploading = false;
				this.$refs.upload.abort();
				this.$message.error(response.msg);
			}
		},
		submitFileForm() {
			this.$refs.upload.submit();
		},
		handleFileExceed(response) {
			this.$alert("只能上传一个文件");
		},
		importOpnes() {
			this.importOpen = false;
			this.importData = [];
			this.importSucceedNumber = 0;
			this.importErrorNumber = 0;
		}
	}
};
</script>
<style scoped>
.from {
	margin-top: 15px;
}
.item_btn {
	float: right;
}
</style>
